/**
 * Parsed metadata stored in a ProofreaderOperation's `meta` field.
 *
 * The AI Toolkit's proofreader workflow stores each operation's `meta` string
 * on the resulting suggestion as `suggestion.metadata.operationMeta`. Consumers
 * (e.g. AiSuggestBubble) parse this JSON to display per-violation details.
 */
export interface ProofreaderOperationMeta {
  ruleId: string;
  category: string;
  severity: 'error' | 'warning' | 'suggestion';
  message: string;
  ruleTitle: string;
  ruleDescription?: string;
}

/**
 * Safely parse a `ProofreaderOperationMeta` from a JSON string.
 * Returns `null` if the string is falsy or not valid JSON.
 */
export function parseOperationMeta(
  raw: string | undefined,
): ProofreaderOperationMeta | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ProofreaderOperationMeta;
  } catch {
    return null;
  }
}
